var map = {
	"./checkout": 5076,
	"./checkout.json": 5076,
	"./comment": 7618,
	"./comment.json": 7618,
	"./message": 6916,
	"./message.json": 6916,
	"./order": 5805,
	"./order.json": 5805,
	"./price": 6331,
	"./price.json": 6331,
	"./product": 477,
	"./product.json": 477,
	"./ticket": 1026,
	"./ticket.json": 1026,
	"./transactions": 1916,
	"./transactions.json": 1916,
	"./user-profile": 8579,
	"./user-profile.json": 8579
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6616;